<template>
  <section class="selected-categories">
    <img
      v-for="category in categoryImages"
      :key="category.id"
      :class="{ disabled: !isSelected(category.id) }"
      :src="category.imageUrl"
      :alt="category.name"
      width="26"
      height="26"
      fetchpriority="low"
    />
  </section>
</template>

<script setup lang="ts">
import { getCampsiteCategoriesPresenter } from '~/apps/categories/presenter-json/CampsiteCategoriesUpdaterJson'

const props = withDefaults(
  defineProps<{
    selectedIds?: Array<string>
    enabledOnAllUnselected?: boolean
  }>(),
  {
    selectedIds: undefined,
    enabledOnAllUnselected: false,
  },
)

const route = useRoute()
const categoriesPresenter = getCampsiteCategoriesPresenter(
  (route.params.lang as string) || 'en-gb',
)
const categories = categoriesPresenter.list
const categoryImages = loadImages()

function loadImages() {
  const imageUrls = import.meta.glob<string>(
    '@/assets/images/category-icons/*.svg',
    {
      eager: true,
      query: '?url',
      import: 'default',
    },
  )

  return categories.map((category) => {
    return {
      ...category,
      imageUrl: imageUrls[`/assets/images/category-icons/${category.slug}.svg`],
    }
  })
}

function isSelected(id: string) {
  if (props.enabledOnAllUnselected && props.selectedIds?.length === 0) {
    return true
  }
  return props.selectedIds?.includes(id)
}
</script>

<style scoped>
section {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin: 0.5em 0 0;
}

img {
  width: auto;
  height: 1.5em;
}

.selected-categories img ~ img {
  margin-left: 0.4em;
}

.selected-categories ~ .touring-pitches {
  margin-left: 0.25em;
}

.disabled {
  filter: grayscale(1);
  opacity: 0.3;
}
</style>
